import { render, staticRenderFns } from "./TeacherImglink.vue?vue&type=template&id=55820722&"
import script from "./TeacherImglink.vue?vue&type=script&lang=js&"
export * from "./TeacherImglink.vue?vue&type=script&lang=js&"
import style0 from "./TeacherImglink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeacherImglink.vue"
export default component.exports